import type { ReactNode } from 'react'
import ChevronDown from 'srs.sharedcomponents/lib/esm/assets/icons/chevronDown'
import ChevronUp from 'srs.sharedcomponents/lib/esm/assets/icons/chevronUp'
import { Label, LabelChevron } from '../styles'

type TextChevronProps = {
  children: ReactNode
  isHovered?: boolean
}

const HoverChevronIcon = ({ isHovered = true }) => {
  return <div>{isHovered ? <ChevronDown /> : <ChevronUp />}</div>
}

const Chevron = ({ children, isHovered = true }: TextChevronProps) => {
  return (
    <LabelChevron>
      <Label className="web" href="#" onClick={(e) => e.preventDefault()}>
        {children}
      </Label>
      <HoverChevronIcon isHovered={isHovered} />
    </LabelChevron>
  )
}

export { Chevron }
